import React from "react";
import { Link2, MessageCircle, Send } from "lucide-react";
import { toast } from "sonner";

const XIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>
);
const FbIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
);
const WaIcon = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.945C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 018.413 3.488 11.824 11.824 0 013.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 001.509 5.26l-.999 3.648 3.98-1.607zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.767.967-.94 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z" /></svg>
);
const TgIcon = Send;

export function ShareRow({ title, summary, url, compact = false }) {
  const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const enc = encodeURIComponent(shareUrl);
  const encText = encodeURIComponent(title || "");
  const links = {
    whatsapp: `https://wa.me/?text=${encText}%20${enc}`,
    x: `https://twitter.com/intent/tweet?text=${encText}&url=${enc}`,
    telegram: `https://t.me/share/url?url=${enc}&text=${encText}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${enc}`,
  };

  const nativeShare = async () => {
    try {
      if (navigator.share) { await navigator.share({ title, text: summary || title, url: shareUrl }); return true; }
    } catch { return true; }
    return false;
  };
  const copy = async () => {
    try { await navigator.clipboard.writeText(shareUrl); toast.success("Link copied to clipboard"); }
    catch { toast.error("Could not copy link"); }
  };

  const Btn = ({ onClick, href, label, testid, children }) => {
    const cls = "grid place-items-center w-10 h-10 rounded-full border border-white/12 text-zinc-300 hover:text-[#ccff00] hover:border-[#ccff00]/50 transition-colors";
    if (href) return <a data-testid={testid} href={href} target="_blank" rel="noreferrer" aria-label={label} title={label} className={cls}>{children}</a>;
    return <button data-testid={testid} type="button" onClick={onClick} aria-label={label} title={label} className={cls}>{children}</button>;
  };

  return (
    <div data-testid="share-row" className="flex items-center gap-2 flex-wrap">
      {!compact && <span className="font-mono-cl text-[10px] tracking-[0.2em] uppercase text-zinc-500 mr-1">Share</span>}
      <Btn testid="share-native" onClick={async () => { if (!(await nativeShare())) copy(); }} label="Copy link"><Link2 className="w-4 h-4" /></Btn>
      <Btn testid="share-whatsapp" href={links.whatsapp} label="Share on WhatsApp"><WaIcon width={16} height={16} /></Btn>
      <Btn testid="share-x" href={links.x} label="Share on X"><XIcon width={15} height={15} /></Btn>
      <Btn testid="share-telegram" href={links.telegram} label="Share on Telegram"><TgIcon className="w-4 h-4" /></Btn>
      <Btn testid="share-facebook" href={links.facebook} label="Share on Facebook"><FbIcon width={16} height={16} /></Btn>
    </div>
  );
}
